import React, { useState } from "react";

import copy from "../../assets/icons/copy.svg";

const CopyButton = ({ copyText }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleCopy = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(copyText);

    setShowTooltip(true);
    setTimeout(() => setShowTooltip(false), 1500); // Tooltip shows for 1.5 seconds
  };

  return (
    <div className="relative  mx-2  flex ">
      <button onClick={(e) => handleCopy(e)} className="p-[0.5px] hover:bg-[#CED3D9] rounded-full  my-auto">
        <img src={copy} alt="" width={16} height={16} style={{ minWidth: "16px", minHeight: "16px" }} />
      </button>
      {showTooltip && (
        <div className="absolute   left-1/2 transform -translate-x-1/2 mb-2 bg-gray-800 text-white text-xs px-2 py-1 rounded">
          کپی{`\u202F`}شد
        </div>
      )}
    </div>
  );
};

export default CopyButton;
